import { useContext } from 'react';
import { GlobalContext } from '@/routes/context';
import defaultLocale from '@/locale';

function useLocale(locale = null) {
  const { lang } = useContext(GlobalContext);
  return (locale || defaultLocale)[lang || 'en-US'] || {};
}

export default useLocale;
